import { render, staticRenderFns } from "./EcDashboard.vue?vue&type=template&id=3abe075c&"
import script from "./EcDashboard.vue?vue&type=script&lang=js&"
export * from "./EcDashboard.vue?vue&type=script&lang=js&"
import style0 from "./EcDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports